import React from 'react';
import {connect} from 'react-redux';
import {push} from 'react-router-redux';
import { FormattedMessage, defineMessages } from 'react-intl';
import BetGames from '../betgames/BetGames.jsx';
import UnauthedBetGames from '../betgames/UnauthedBetGames.jsx';
import {getToken as getTokenAction} from 'actions/betGames/creators';

const messages = defineMessages({
    disclaimer1: {
        id: 'betgames.disclaimer1',
        defaultMessage: 'Ставки на BetGamesTV основаны только на предстоящих реальных событиях. Данный вид ставок не является онлайн-казино, поскольку не относится к предусмотренному Законом «Об игорном бизнесе» понятию «азартной игры».'
    },
    disclaimer2: {
        id: 'betgames.disclaimer2',
        defaultMessage: 'БК «Fair Play» не организовывает данный вид событий и не участвует в них, равно как и участники пари (игроки). Организатором данного вида реальных событий является компания «TV ZAIDIMAI». События транслируются в режиме реального времени и не зависят от Букмекера или участников пари (игроков). Результаты событий формируются организатором независимо от БК «Fair Play» и публикуются на его официальном сайте.'
    }
})

class BironexPage extends React.Component {
    state = { 
        showBetgames: false 
    };
    static contextTypes = {
        footer: React.PropTypes.object
    };

    componentWillMount() {
        if (this.props.user && this.props.betGames.get('token') === undefined && this.props.countryCode === 'KG') {
            this.props.getTokenAction();
        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.user !== nextProps.user && nextProps.user && nextProps.betGames.get('token') === undefined && nextProps.betGames.get('fetching') === false && this.props.countryCode === 'KG') {
            this.props.getTokenAction();
        }
    }

    onSubmit = event => {
        this.setState({ showBetgames: true });
      };

    render() {
        const {user, betGames} = this.props;

        if (this.props.countryCode !== 'KG') {
            return false;
        }

        return (
            <div className='betgames' id='betgames-wrapper'>
                <div className='betgames__disclaimer'>
                    <p><strong><FormattedMessage {...messages.disclaimer1} /></strong></p>
                    <p><FormattedMessage {...messages.disclaimer2} /></p>
                </div>
                <div className="betgames__initial" hidden={this.state.showBetgames}>
                    <p>Технические работы до 09.03.2020, приносим извинения за неудобства.</p>
                    {/* <button className="btn__green"onClick={this.onSubmit}>Подключиться</button> */}
                </div>
                {(user && betGames.get('token') !== undefined && this.state.showBetgames == true) &&
                    <BetGames betGames={betGames} />
                }
                {(user === null && betGames.get('token') === undefined && this.state.showBetgames == true) &&
                    <UnauthedBetGames betGames={betGames} />
                }
                {this.context.footer}
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.auth.get('user'),
        countryCode: state.application.get('countryCode'),
        betGames: state.betGames
    }
};

export default connect(mapStateToProps, {getTokenAction, push})(BironexPage);


// WEBPACK FOOTER //
// ./js/sport-betting/components/pages/BetGamesPage.jsx